import React from 'react';
import LocalizedStrings from 'react-localization';
import img1 from '../../img/11-mob.png';
import img1Webp from '../../img/11-mob.webp';
import img2 from '../../img/11.png';
import img2Webp from '../../img/11.webp';

function AutoBannerBig(props) {
  const strings = new LocalizedStrings({
    ru: {
      make: 'Оформляй и зарабатывай!',
      txt: 'Оформи карту через POLIS.UA и получи персональный промокод на кешбек в 10% на оформление автогражданки',
      get: 'Оформить',
    },
    ua: {
      make: 'Оформлюй та заробляй!',
      txt: 'Оформи карту через POLIS.UA та отримай персональний промокод на кешбек у 10% на оформлення автоцивілки',
      get: 'Оформити',
    },
  });
  strings.setLanguage(props.locale);
  return (
    <section className="auto-banner2 banner-block container">
      <div className="flex flex_j-space-between">
        <div className="txt">
          <h3>{strings.make}</h3>
          <p>{strings.txt}</p>
          <a href={props.locale === "ua" ? "https://polis.ua/uk" : "https://polis.ua/"} className="btn">{strings.get}</a>
        </div>
        <div className="r-block">
          <div className="action">10%</div>
          <div className="img">
            <picture>
              <source srcSet={img2Webp} type="image/webp" />
              <img src={img2} alt="car" />
            </picture>
            <picture>
              <source srcSet={img1Webp} type="image/webp" />
              <img src={img1} alt="car" className="img-mob" />
            </picture>
          </div>
        </div>
      </div>
      <div className="bg">
        <svg width={718} height={239} viewBox="0 0 718 239" fill="none" xmlns="http://www.w3.org/2000/svg" className="bg-1">
          <path d="M718 0V236C718 237.657 716.657 239 715 239H0.000488281C44.4677 179.755 109.943 238.308 168 204.567C209.939 180.194 211.298 129.614 258.5 118.993C288.812 112.172 285.089 121.356 315 112.917C358.866 100.541 364.611 56.5562 404 33.4189C470.822 -5.83142 541.403 67.1619 611.5 50.1286C657.198 39.0244 718 0 718 0Z" fill="url(#b1)" />
          <defs>
            <linearGradient id="b1" x1="377.766" y1="238.998" x2="715.989" y2="3.24702" gradientUnits="userSpaceOnUse">
              <stop stopColor="#1487CF" />
              <stop offset="0.293" stopColor="#1487CF" />
              <stop offset={1} stopColor="#FFD83A" />
            </linearGradient>
          </defs>
        </svg>
        <svg width={818} height={239} viewBox="0 0 818 239" fill="none" xmlns="http://www.w3.org/2000/svg" className="bg-2">
          <path opacity="0.2" d="M361 57.9852C468 57.9852 463.5 0 566 0C660.095 0 793.796 0 815.093 0C816.749 0 818 1.34315 818 3V236C818 237.657 816.657 239 815 239H0.000488281C13.6195 207.738 43.0923 172.443 86.5005 166.897C129.909 161.35 198.412 187.065 231.001 166.897C323.752 109.493 254 57.9852 361 57.9852Z" fill="url(#b2)" />
          <defs>
            <linearGradient id="b2" x1="397.756" y1={239} x2="731.851" y2="11.3356" gradientUnits="userSpaceOnUse">
              <stop stopColor="#1487CF" />
              <stop offset="0.293" stopColor="#1487CF" />
              <stop offset={1} stopColor="#FFD83A" />
            </linearGradient>
          </defs>
        </svg>
      </div>
      <div className="bg-mob">
        <svg width={320} height={184} viewBox="0 0 320 184" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path opacity="0.2" d="M103.921 44.6413C186.5 44.6413 183.027 0 262.134 0C333.731 0 435.042 0 453.631 0C455.288 0 456.621 1.34315 456.621 3V181C456.621 182.657 455.278 184 453.621 184H-174.689C-164.179 159.933 -141.432 132.76 -107.931 128.489C-74.4299 124.219 -21.5607 144.017 3.59018 128.489C75.1733 84.296 21.3409 44.6413 103.921 44.6413Z" fill="url(#bgm1)" />
          <path d="M455.035 0V181C455.035 182.657 453.691 184 452.035 184H-96.9653C-62.7789 138.389 -12.4414 183.467 32.1934 157.491C64.4357 138.727 65.4809 99.7867 101.77 91.6095C125.074 86.3583 122.211 93.4286 145.207 86.9315C178.931 77.4037 183.348 43.5412 213.631 25.7284C265.003 -4.48946 319.266 51.7062 373.157 38.5927C408.289 30.0439 455.035 0 455.035 0Z" fill="url(#bgm)" />
          <defs>
            <linearGradient id="bgm1" x1="132.287" y1={184} x2="389.73" y2="8.13687" gradientUnits="userSpaceOnUse">
              <stop stopColor="#1487CF" />
              <stop offset="0.293" stopColor="#1487CF" />
              <stop offset={1} stopColor="#FFD83A" />
            </linearGradient>
            <linearGradient id="bgm" x1="193.462" y1="183.999" x2="453.725" y2="2.84013" gradientUnits="userSpaceOnUse">
              <stop stopColor="#1487CF" />
              <stop offset="0.293" stopColor="#1487CF" />
              <stop offset={1} stopColor="#FFD83A" />
            </linearGradient>
          </defs>
        </svg>
      </div>
    </section>

  );
}

export default AutoBannerBig;
